import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { Counterparty } from '../../../../entities/Counterparty/service';
import {
  deleteCounterpartyError,
  deleteCounterpartyRequest,
  deleteCounterpartySuccess,
  getCounterpartiesListError,
  getCounterpartiesListRequest,
  getCounterpartiesListSuccess,
  getCounterpartyDetailsError,
  getCounterpartyDetailsRequest,
  getCounterpartyDetailsSuccess,
  postAddCounterpartyError,
  postAddCounterpartyRequest,
  postAddCounterpartySuccess,
  putUpdateCounterpartyError,
  putUpdateCounterpartyRequest,
  putUpdateCounterpartySuccess,
} from './actions';
import {
  DELETE_COUNTERPARTY_REQUEST,
  GET_COUNTERPARTIES_LIST_REQUEST,
  GET_COUNTERPARTY_DETAILS_REQUEST,
  POST_ADD_COUNTERPARTY_REQUEST,
  PUT_UPDATE_COUNTERPARTY_REQUEST,
} from './constants';

function* getCounterpartiesListSaga() {
  try {
    const response: AxiosResponse = yield call(Counterparty.getList);
    const res = response.data.ResponseBody;
    yield put(getCounterpartiesListSuccess(res));
  } catch (e: any) {
    const error = e.toJSON();
    yield put(getCounterpartiesListError(error));
  }
}

function* getCounterpartyDetailsSaga(action: ReturnType<typeof getCounterpartyDetailsRequest>) {
  try {
    const response: AxiosResponse = yield call(Counterparty.getDetails, action.payload.id);
    const res = response.data.ResponseBody;
    yield put(getCounterpartyDetailsSuccess(res));
  } catch (e: any) {
    const error = e.toJSON();
    yield put(getCounterpartyDetailsError(error));
  }
}

function* postAddCounterpartySaga(action: ReturnType<typeof postAddCounterpartyRequest>) {
  try {
    const response: AxiosResponse = yield call(Counterparty.create, action.payload);
    const res = response.data.ResponseBody;
    yield put(postAddCounterpartySuccess(res));
    yield put(getCounterpartiesListRequest());
  } catch (e: any) {
    const error = e.toJSON();
    yield put(postAddCounterpartyError(error));
  }
}

function* putUpdateCounterpartySaga(action: ReturnType<typeof putUpdateCounterpartyRequest>) {
  try {
    const response: AxiosResponse = yield call(Counterparty.update, action.payload);
    const res = response.data.ResponseBody;
    yield put(putUpdateCounterpartySuccess(res));
    yield put(getCounterpartiesListRequest());
  } catch (e: any) {
    const error = e.toJSON();
    yield put(putUpdateCounterpartyError(error));
  }
}

function* deleteCounterpartySaga(action: ReturnType<typeof deleteCounterpartyRequest>) {
  try {
    yield call(Counterparty.delete, action.payload.id);
    yield put(deleteCounterpartySuccess(true));
    yield put(getCounterpartiesListRequest());
  } catch (e: any) {
    const error = e.toJSON();
    yield put(deleteCounterpartyError(error));
  }
}

export function* CounterpartySagaWatcher() {
  yield takeLatest(GET_COUNTERPARTIES_LIST_REQUEST, getCounterpartiesListSaga);
  yield takeLatest(GET_COUNTERPARTY_DETAILS_REQUEST, getCounterpartyDetailsSaga);
  yield takeLatest(POST_ADD_COUNTERPARTY_REQUEST, postAddCounterpartySaga);
  yield takeLatest(PUT_UPDATE_COUNTERPARTY_REQUEST, putUpdateCounterpartySaga);
  yield takeLatest(DELETE_COUNTERPARTY_REQUEST, deleteCounterpartySaga);
}
